export interface RoleDefinition {
  routes: string[];
  tabs: string[];
}

export const RoleConfig: { [key: string]: RoleDefinition } = {
  fullAccess: {
    routes: ['/home', '/workflow', '/retrieval', '/webupload', '/vendorinfo','/paymentcode','/substitution'],
    tabs: ['My Work Basket', 'Workflow', 'Retrieval', 'Web Upload', 'Vendor Classification','Payment Code','Substitution']
  },
  workflowRetrievalApproverOnly: {
    routes: ['/home', '/workflow', '/retrieval'],
    tabs: ['My Work Basket', 'Workflow', 'Retrieval']
  },
  approver: {
    routes: ['/home', '/retrieval'],
    tabs: ['My Work Basket', 'Retrieval']
  },
  viewReadOnly: {
    routes: ['/retrieval'],
    tabs: ['Retrieval']
  },
  vendorClassificationOnly: {
    routes: ['/vendorinfo'],
    tabs: ['Vendor Classification']
  },
  paymentCodeOnly: {
    routes: ['/paymentcode'],
    tabs: ['Payment Code']
  },
  restrictedVendorClassificationAccess: {
    routes: ['/home', '/workflow', '/retrieval', '/paymentcode'],
    tabs: ['My Work Basket', 'Workflow', 'Retrieval', 'Payment Code']
  },
  restrictedVCPCAccess: {
    routes: ['/home', '/workflow', '/retrieval', '/webupload'],
    tabs: ['My Work Basket', 'Workflow', 'Retrieval', 'Web Upload']
  },
  restrictedPaymentCodeAccess: {
    routes: ['/home', '/workflow', '/retrieval', '/webupload', '/vendorinfo', '/substitution'],
    tabs: ['My Work Basket', 'Workflow', 'Retrieval', 'Web Upload', 'Vendor Classification', 'Substitution']
  },
  workflowRetrievalManagement: {
    routes: ['/home', '/workflow', '/retrieval', '/webupload', '/vendorinfo','/paymentcode', '/substitution'],
    tabs: ['My Work Basket', 'Workflow', 'Retrieval', 'Web Upload', 'Vendor Classification','Payment Code','Substitution']
  },
  workflowRetrievalVendorClassificationAccess: {
    routes: ['/workflow', '/retrieval', '/vendorinfo'],
    tabs: ['Workflow', 'Retrieval', 'Vendor Classification']
  },
  workflowRetrievalAccess: {
    routes: ['/workflow', '/retrieval'],
    tabs: ['Workflow', 'Retrieval']
  },
  approverVendorClassificationSubstitutionAccess: {
    routes: ['/home', '/retrieval', '/vendorinfo', '/substitution'],
    tabs: ['My Work Basket', 'Retrieval', 'Vendor Classification', 'Substitution']
  },
  approverSubstitutionAccess: {
    routes: ['/home', '/retrieval', '/substitution'],
    tabs: ['My Work Basket', 'Retrieval', 'Substitution']
  },
  workflowApproverVCSubstitutionAccess: {
    routes: ['/home', '/workflow', '/retrieval', '/vendorinfo', '/substitution'],
    tabs: ['My Work Basket', 'Workflow', 'Retrieval', 'Vendor Classification', 'Substitution']
  }, 
  nonAdminWithRestrictedVCAccess: {
    routes: ['/home', '/workflow', '/retrieval', '/webupload', '/paymentcode', '/substitution'],
    tabs: ['My Work Basket', 'Workflow', 'Retrieval', 'Web Upload', 'Payment Code','Substitution']
  },
};